<template>
    <div class="navigator" :class="sidebarShow" >
        <div class="navigator-cont" ref="nav">
            <div class="inner">
                <div class="logo">
                    <img :src="setImg('logo')" alt="">
                </div>
                <ul class="nav"> 
                    <router-link
                        exact
                        v-for="(item, index) in navList"
                        :to="item.path"
                        :key="index" 
                        tag="li"
                    >  
                        <span>{{ item.name }}</span>
                        <em>{{ item.title }}</em>
                    </router-link>
                </ul>
            </div>
        </div>
        <div class="navigator-fiexd" :style="{height:navHeight+'px'}"></div>
        <div class="drawer-bg" @click="openNav"></div>
        <div ref="navbar" class="nav-bar">
            <div class="nav-btn" @click="openNav">
                导航
            </div>
        </div>
    </div>
</template>
<script>  
    import store from '@/store';
    export default {
        name: "Navigator",
        data() {
            return { 
                sidebarShow: '',
                isPc: true,
                navHeight: 0,
                navList:[{
                             path:'/',
                             name:'首页',
                             title:'HOME'
                         },
                         {
                             path:'/project',
                             name:'产品介绍',
                             title:'PROJECT'
                         },
                         {
                             path:'/about',
                             name:'关于我们',
                             title:'ABOUT US'
                         }]
            };
        },
        created() {   
        },
        mounted() {
            this.isPcFun();  
            this.navHeight = this.isPc ? this.$refs.nav.offsetHeight : this.$refs.navbar.offsetHeight;
            store.dispatch('app/navHeight', this.navHeight)
        },
        methods: { 
            isPcFun() {
                const Terminal = function () {
                    var a = navigator.userAgent.toLowerCase();
                    return {
                        weChat: a.match(/MicroMessenger/i) == "micromessenger",
                        android: a.indexOf("android") > -1 || a.indexOf("linux") > -1,
                        iPhone: a.indexOf("iphone") > -1,
                        url: location.pathname
                    }
                }();
                if (Terminal.weChat || Terminal.android || Terminal.iPhone) {
                    this.isPc = false;
                } else{
                    this.isPc = true;
                }
                store.dispatch('app/isPc', this.isPc);

            },
            setImg(path) {
                return require(`@/assets/images/${path}.png`)
            },
            openNav() {
                this.sidebarShow = this.sidebarShow =='' ? 'sidebar-show' :'';
            }
        },
    };
</script>
<style lang="scss">
@import "@/assets/scss/mixins/_variables";
.navigator-fiexd{
    height: 83px;
}
.nav-bar{
    display: none;
}
.navigator-cont{
    position: fixed;
    top:0;
    left:0;
    z-index: 999;
    width:100%;
    background: #0458CC;
    // height: 83px;
    .inner{
        display: flex;
        justify-content:space-between;
        align-items:center;
        height: 100%;
        .logo{
            width: 137px;
            height:38px;
        }
        .nav{
            display: flex; 
            align-items:center;
            height: 100%;
            color:#fff;
            li{
                display: flex; 
                flex-wrap:wrap;
                align-items:center;
                height: 100%;
                text-align: center;
                padding:20px 60px;
                cursor: pointer;
                &:hover,
                &.router-link-active{
                    background: #043F95;
                } 
                em,span{
                    width:100%;
                    display: block;
                }
            }
        }
    }
}
@media only screen and (max-width: 750px) { 
    .navigator,
    .navigator-cont{
        height: 100%;
    }
    .sidebar-show{
        .navigator-cont{
            left: 0;
        }
        .drawer-bg{
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,.4);
            z-index: 100;
        }
    }
    .navigator-cont{
        width: 30%;
        transition: 0.5s;
        left: -30%;
        .inner{
            display: block;
            width: 100%;
            padding:0;
            .logo{
                margin:0 auto;
                padding:10px;
                width:93px;
                height: 60px;
                img{ 
                    object-fit:contain;
                }
            }
            .nav{
               display: block;
               li{
                   position: relative;
                   display: block;
                   padding:10px 0;
                   height: auto; 
                   border-radius: 5px;
                   margin:10px 0;
                   &::after{
                       content: '';
                       position: absolute;
                       left: 50%;
                       bottom:0;
                       transform: translateX(-50%);
                       display: block;
                       width:50%;
                       height:2px;
                       border-radius: 1px;
                       background: #043F95;
                   }
                   &:last-child{
                       &::after{
                           display: none;
                       }
                   }
               } 
            }
        }
    }
    .nav-bar{
        position: fixed;
        top:0;
        left: 0;
        z-index: 99;
        width: 100%;
        display: block; 
        height: 50px;
        border-bottom: 1px solid #ecf5ff;
        background:#fff url('~@/assets/images/logo.png') no-repeat 50%/auto 63%;
        .nav-btn{
            float: left; 
            padding-left: 35px;
            font-size: 16px;
            font-weight: 600; 
            height: 100%;
            line-height:50px;
            background: url('~@/assets/images/icon/nav.png') no-repeat left 10px center;
            background-size: 20px 20px;

        }
    }
}
</style>
